/**
 * @description Clears the localStorage and triggers a reload after session data was restored
 *
 * @return void
 */
function successRestoreSession(data) {
    localStorage.clear();
    if (data.success) {
        location.reload();
    }
}